import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import FreePhilosophySection from '../components/FreePhilosophySection';
import { initAnalytics, trackUserJourney } from '../utils/analytics';

const PhilosophiePage = () => {
  useEffect(() => {
    const cleanup = initAnalytics('philosophie_page');
    trackUserJourney('philosophie_page_visit', 'values');
    return cleanup;
  }, []);

  return (
    <>
      <Helmet>
        <title>Philosophie Sun Spot - Plateforme gratuite de spots panoramiques</title>
        <meta name="description" content="Philosophie Sun Spot : plateforme 100% gratuite et communautaire pour découvrir des spots panoramiques, bancs avec vue et lieux secrets accessibles à tous." />
        <link rel="canonical" href="https://sun-spot.app/philosophie" />
        <meta property="og:url" content="https://sun-spot.app/philosophie" />
        <meta property="og:title" content="Philosophie Sun Spot - Engagement gratuit" />
        <meta property="og:description" content="Notre philosophie Sun Spot : plateforme 100% gratuite et communautaire pour tous les amoureux de spots panoramiques." />
      </Helmet>
      
      <div className="pt-16">
        <FreePhilosophySection />
      </div>
    </>
  );
};

export default PhilosophiePage;